import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * オンライン面会予約 API 操作クラス
 */
export default class OnlineReservation {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST OnlineReservation
   */
  public async post(userStore: LoginUser, residentId: number, requestBody: OnlineReservationPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OnlineReservation, formatParams);

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface OnlineReservationPostModel {
  groupId: number;
  text?: string;
  familyId: number;
  familyName: string;
  familyRelation: string;
  familyPosition: string;
  familyTel: string;
  familyLineId?: string;
  familyMailaddress?: string;
  datetime: number;
  consented: boolean;
  /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
  isSharedReservation: boolean;
  userId: string;
  userName: string;
  inputType: InputType;
}

export enum InputType {
  FACILITY_APP = 0,
  BOT_APP = 1
}
